// @ts-nocheck

import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import { getTimezoneListWithOffsets } from '../../../main/support/dateUtils';
import Dropdown from './Dropdown';

class TimezoneList extends PureComponent {
  static propTypes = {
    /**
     * Callback triggered on the parent when a value is selected from the dropdown
     */
    onChange: PropTypes.func.isRequired,
    /**
     * What value the dropdown should have selected. If that value is in the
     * list of options, the label associated with that value will display.
     * If that value is not in the list of options, no value will display.
     */
    value: PropTypes.string,
    /**
     * Either a string or an object to pass into classNames library
     * (i.e. `{ 'foo-class': true, 'bar-class': false }`)
     */
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    /**
     * Pass in if you want to render a label over the TimezoneList component
     */
    label: PropTypes.string,
    /**
     * Pass in if you want to overwrite the default 'timezone-dropdown' data-testid
     */
    testid: PropTypes.string,

    disabled: PropTypes.bool,
  };

  static defaultProps = {
    className: 'h_mt-20 h_mb-5',
    testid: 'timezone-dropdown',
  };

  _onChange = (valueLabelObj) => {
    // The parent only cares about the value, not the label
    this.props.onChange(valueLabelObj.value);
  };

  render() {
    const list = getTimezoneListWithOffsets().map((timezone) => ({
      label: timezone.label,
      value: timezone.name,
    }));

    return (
      <Dropdown
        disabled={this.props.disabled}
        label={this.props.label}
        options={list}
        searchable={true}
        value={this.props.value}
        onChange={this._onChange}
        clearable={false}
        complete={true}
        outerClassName={classNames('timezone-dropdown', this.props.className)}
        testid={this.props.testid}
      />
    );
  }
}

export default TimezoneList;
